import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/actions/index';
import OTPVerification from '../../../component/SingIn/OTPVerification/OTPVerification';

class otpVerificationContainer extends Component {

    constructor(props) {
        super(props);
    }


    otpVerification = (values) => {
        this.props.otpVerification(values);
    }

    resendOPT = (user) => {
        this.props.resendOPT(user);
    }



    render() {
        return (
            <OTPVerification
                isLoading={this.props.isLoading}
                resendOPT={this.resendOPT}
                otpVerification={this.otpVerification}
                />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.authReducer.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resendOPT: (user) => dispatch(actions.resendOPT(user)),
        otpVerification: (user) => dispatch(actions.otpVerification(user))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(otpVerificationContainer);